import { useQuery, useMutation } from "@tanstack/react-query";
import {
  getBillingStatus,
  getBillingUsageHistory,
  createCheckoutSession,
  createPortalSession,
  type BillingStatus,
  type BillingSessionUrl,
  type BillingUsageHistory,
} from "../api/billing.api";
import { ApiError } from "@/lib/api/client";

export const billingKeys = {
  all: ["billing"] as const,
  status: () => [...billingKeys.all, "status"] as const,
  usageHistory: () => [...billingKeys.all, "usage-history"] as const,
};

export function useBillingStatus() {
  return useQuery<BillingStatus, ApiError>({
    queryKey: billingKeys.status(),
    queryFn: getBillingStatus,
  });
}

export function useBillingUsageHistory() {
  return useQuery<BillingUsageHistory, ApiError>({
    queryKey: billingKeys.usageHistory(),
    queryFn: getBillingUsageHistory,
    staleTime: 1000 * 60 * 5,
  });
}

export function useCheckout() {
  return useMutation<
    BillingSessionUrl,
    ApiError,
    { plan: "pro" | "scale"; interval?: "monthly" | "annual" }
  >({
    mutationFn: createCheckoutSession,
  });
}

export function usePortal() {
  return useMutation<BillingSessionUrl, ApiError, void>({
    mutationFn: createPortalSession,
  });
}
